import React from "react";
import PropTypes from "prop-types";
import { useSpring } from "react-spring";

import Drawer from "./Drawer";

const ControlledDrawer = ({ isOpen, ...props }) => {
  const sprungStyles = useSpring({
    to: isOpen ? Drawer.open : Drawer.closed,
    config: { velocity: isOpen ? Drawer.initialVelocity : 0 }
  });

  return <Drawer style={sprungStyles} {...props} />;
};

ControlledDrawer.propTypes = {
  isOpen: PropTypes.bool
};

ControlledDrawer.defaultProps = {
  isOpen: false
};

export default ControlledDrawer;
